'use client';
import React, { useCallback, useEffect, useState } from 'react';
import searchIcon from '@images/ico_search.svg';
import Image from 'next/image';
import { useRouter } from '@/navigation';

type GeneSearchBarProps = {
  searchQuery: string;
};

function GeneSearchBar({ searchQuery }: GeneSearchBarProps) {
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState(searchQuery);

  useEffect(() => {
    setSearchTerm(searchQuery);
  }, [searchQuery]);

  const handleSearch = useCallback(() => {
    const trimmed = searchTerm.trim();
    if (trimmed) {
      router.push(`/gene-browser?q=${encodeURIComponent(trimmed)}`);
    }
  }, [searchTerm, router]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, []);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        handleSearch();
      }
    },
    [handleSearch],
  );

  return (
    <div className="sticky top-0 z-[1] col-[1/4] grid grid-cols-[1fr_min(100%,320px)_1fr] gap-y-4 bg-white py-4 md:grid-cols-[1fr_min(100%,493px)_1fr]">
      <div className="col-start-2">
        <div className="flex items-center rounded-xl bg-3b-background-light p-2 px-4 focus-within:ring-2 focus-within:ring-3b-blue-light-900">
          <input
            type="text"
            aria-label="Search for gene symbol"
            className="w-full border-none bg-inherit outline-none"
            placeholder="Search for gene symbol, ex: ACSM2A"
            value={searchTerm}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
          <button type="button" aria-label="Search" onClick={handleSearch}>
            <Image
              src={searchIcon}
              alt="search"
              className="mr-2.5 h-[25px] w-[25px] cursor-pointer"
            />
          </button>
        </div>
      </div>
    </div>
  );
}

export default GeneSearchBar;
